import { useTranslation } from 'react-i18next';

const TextoPiePgina = ({ elementosweb, lang }) => {

    const { t } = useTranslation();

    return (
        <div className="p-5 text-center potblur">
            {elementosweb.pie_pagina && <p className="p-5 mb-0 text-center border-top">{elementosweb.pie_pagina[lang]}</p>}
        </div>

    );
};

export default TextoPiePgina;
